<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="row mt-2">
  <div class="col-12">
    <mat-accordion id="RuleDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel template-3-mat-panel">
          <div
            class="save_title w-100 d-flex align-items-center gap-2 justify-content-between"
          >
            <mat-panel-title>
              <span class="text-header inc-f"> Overall Assessment</span>
              <span
                *ngIf="versionHistoryData.isVersonHistory"
                class="marking-changed-fields"
                >Version {{ versionHistoryData.versionNo }}
              </span>
            </mat-panel-title>
            <span
              *ngIf="!versionHistoryData.isVersonHistory"
              class="cursor-pointer text-primary cursor-pointer"
              (click)="openDialog(); $event.stopPropagation()"
              ><i class="fa fa-history text-dark"></i> Version History
            </span>
            <button
              *ngIf="!versionHistoryData.isVersonHistory"
              [disabled]="isButtonDisabled ? true : !userPermissionList?.SaveOvrAllAsmnt"
              class="save_btn mr-2 text-primary cursor-pointer"
              (click)="saveAssessmentData(); $event.stopPropagation()"
            >
              <lucide-icon
                name="save"
                size="16"
                class="text-primary"
              ></lucide-icon>
              Save
            </button>
          </div>
        </mat-expansion-panel-header>
        <div id="RuleDetails">
          <div class="row ml-2">
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Assessor Name 
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-chip-grid class="t3_matchip" #assessorNameInputList>
                <ng-container *ngFor="let item of assessorNameFilterList">
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeAssessor(item.value)"
                    class="mat-chip-category"
                  >
                    {{ item.name }}
                    <mat-icon
                      matChipRemove
                      *ngIf="userPermissionList?.AssessorName"
                      >cancel</mat-icon
                    >
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #assessorInput
                  [formControl]="searchAssessorCntrl"
                  [matAutocomplete]="assessorAutoComplete"
                  [matChipInputFor]="assessorNameInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addAssessor($event)"
                  #assessorAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                  [readonly]="!userPermissionList?.AssessorName"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #assessorAutoComplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)"
              >
                <mat-option *ngFor="let obj of searchedAssessors" [value]="obj.value">
                  <span class="option">
                    {{ obj.name }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Assessment Category
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.assessmentCategory"
                [disabled]="!userPermissionList?.AssessmentCategory"
              >
                <mat-option
                  *ngFor="
                    let option of overallAssessmentDropdownList.assessmentCategory
                  "
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Assessment Status
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.assessmentStatus"
                [disabled]="!userPermissionList?.AssessmentStatus"
              >
                <mat-option
                  *ngFor="
                    let option of overallAssessmentDropdownList.assessmentStatus
                  "
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Assessment Date
                <!-- <span class="stars">*</span> -->
              </label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="assessmentDueDate"
                  (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  name="AssessmentDueDate"
                  [(ngModel)]="overallAssessmentData.assessmentDate"
                  [disabled]="!userPermissionList?.AssessmentDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="assessmentDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate></mat-datepicker>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Next Assessment Due
                <!-- <span class="stars">*</span> -->
              </label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="nextassessmentDueDate"
                  (click)="nextassessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  name="nextassessmentDueDate"
                  [(ngModel)]="overallAssessmentData.nextAssessmentDueDate"
                  [disabled]="!userPermissionList?.NextAssessmentDue"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="nextassessmentDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #nextassessmentDueDate></mat-datepicker>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Assessor Team
                <!-- <span class="stars">*</span> -->
              </label>
              
              <mat-chip-grid #topicList>
                <mat-chip-row *ngFor="let topic of assessorTeam" [selectable]="selectable" 
                  (removed)="removeTopic(topic)">
                  {{topic}}
                  <mat-icon matChipRemove
                  [disabled]="!userPermissionList?.AssessorName"
                    class="clear-icons">clear</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoTopicExecutive="matAutocompleteTrigger" 
                  [disabled]="!userPermissionList?.AssessorName"
                   #topicInput [formControl]="searchTopicCntrl" [matAutocomplete]="topicAutocomplete"
                  [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addTopic($event)">
              </mat-chip-grid>
              <mat-autocomplete #topicAutocomplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
              
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                > Impacted BU
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-chip-grid #topicList2>
                <mat-chip-row *ngFor="let topic of impactBussinessArea" [selectable]="selectable"
                  (removed)="removeTopic2(topic)">
                  {{topic}}
                  <mat-icon matChipRemove
                  [disabled]="!userPermissionList?.ImpactedBusinessArea"
                    class="clear-icons">clear</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                [disabled]="!userPermissionList?.ImpactedBusinessArea"
                  #trigautoTopicExecutive="matAutocompleteTrigger" 
                  #topicInput2 [formControl]="searchTopicCntrl2" [matAutocomplete]="topicAutocomplete2"
                  [matChipInputFor]="topicList2" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addTopic2($event)">
              </mat-chip-grid>
              <mat-autocomplete #topicAutocomplete2="matAutocomplete" (optionSelected)="selectedTopicEvent2($event)">
                <mat-option *ngFor="let topic of searchedTopic" [value]="topic">
                  {{topic}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Compliance Status
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.complianceStatus"
                [disabled]="!userPermissionList?.ComplianceStatus"
              >
                <mat-option
                  *ngFor="
                    let option of overallAssessmentDropdownList.complianceStatus
                  "
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >LBG Impact
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.lbgImpact"
                [disabled]="!userPermissionList?.LBGImpact"
              >
                <mat-option
                  *ngFor="let option of overallAssessmentDropdownList.lbgList"
                  [value]="option == 'Yes' ? true : false"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >RFB Impact
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.rfbImpact"
                [disabled]="!userPermissionList?.RFBImpact"
              >
                <mat-option
                  *ngFor="let option of overallAssessmentDropdownList.rfbList"
                  [value]="option == 'Yes' ? true : false"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >LBCM Impact
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.lbcmImpact"
                [disabled]="!userPermissionList?.LBCMImpact"
              >
                <mat-option
                  *ngFor="let option of overallAssessmentDropdownList.lbcmList"
                  [value]="option == 'Yes' ? true : false"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20"
            >
              <label class="control-label d-block fw"
                >Actions Required?
                <!-- <span class="stars">*</span> -->
              </label>
              <input
                [(ngModel)]="overallAssessmentData.isActionRequired"
                type="checkbox"
                style="vertical-align: middle; width: 16px; height: 16px"
                [disabled]="!userPermissionList?.ActionRequired"
              />
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-12 mt-5" *ngIf="!isBulkUpdate">
              <div class="header-text">
                <span class="control-label fw d-block mb-2">
                  Assessment Findings
                </span>
              </div>
              <app-ck-editor-revision
                *ngIf="!isLoader"
                class="ck_editor_min_height"
                [accessType]="accessType"
                [data]="overallAssessmentData.assessmentFindings"
                [userInfo]="user"
                [noteId]="'AssessmentFindings'"
                [editorUsers]="
                  overallAssessmentData.muteAssessmentFindingsUsers
                "
                [selfAssessmentId]="summaryDetailsId"
                (childVariableChange)="
                  onChildVariableChangeT3($event, 'AssessmentFindings')
                "
                (saveEditorDate)="onEditorSave($event)"
                [isSaveDisable]="!userPermissionList?.AssessmentFindings"
              ></app-ck-editor-revision>
            </div>
            <div class="col-12" *ngIf="!isBulkUpdate">
              <div class="cursor-pointer" (click)="uploadEvidenceAssessment()">
                <lucide-icon
                  class="text-blue-lucide mr-1"
                  size="15"
                  name="upload"
                ></lucide-icon>
                <span class="text-blue fw"
                  >Upload Evidence - Assessment
                  <i
                    *ngIf="isAssessmentLoader"
                    class="fa fa-circle-o-notch fa-spin"
                    style="font-size: 0.875rem; line-height: 1.5"
                  ></i>
                </span>
                <input
                  id="uploadEviAssessmentT3"
                  (change)="handleFileInput($event.target.files)"
                  type="file"
                  multiple
                  style="display: none"
                /><br />
              </div>
              <div
                class="col-lg-12 mt-3"
                *ngIf="selfAssessmentDocument.length > 0"
              >
                <ng-container *ngFor="let docs of selfAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 1">
                    <span
                      class="fa fa-trash pull-right delete-docs"
                      (click)="openDeleteModel(docs.id, 'overall', userPermissionList?.UplEvdOvrAllAsmnt)"
                    ></span>
                    <span
                      class="cursor-pointer"
                      (click)="
                        downloadDocument(
                          docs.id,
                          docs.fileName,
                          docs.fileExtension,
                          'overall'
                        )
                      "
                    >
                      <i
                        class="fa fa-file-text fa-2x"
                        *ngIf="docs.fileExtension === '.txt'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-text-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.eml' ||
                          docs.fileExtension === '.msg'
                        "
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-pdf-o fa-2x"
                        *ngIf="docs.fileExtension === '.pdf'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.doc'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.docx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xls'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xlsx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-o fa-2x"
                        *ngIf="docs.fileExtension === '.csv'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-code-o fa-2x"
                        *ngIf="docs.fileExtension === '.xml'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-archive-o fa-2x"
                        *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpeg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.png'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.ppt' ||
                          docs.fileExtension === '.pptx'
                        "
                        aria-hidden="true"
                      ></i>
                    </span>
                    <div class="data-div">{{ docs.fileName }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="col-12 mt-2">
    <!-- rule details -->
    <mat-accordion id="reviewDetails" class="mt-2">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel template-3-mat-panel">
          <div
            class="d-flex align-items-center w-100 gap-2 justify-content-between"
          >
            <mat-panel-title>
              <span class="text-header inc-f"> REVIEW DETAILS </span>
            </mat-panel-title>
            <button
              *ngIf="!versionHistoryData.isVersonHistory"
              [disabled]="isButtonDisabledReview ? true : !userPermissionList?.SaveOvrAllReview"
              class="save_btn mr-2 text-primary cursor-pointer"
              (click)="saveReviewData(); $event.stopPropagation()"
            >
              <lucide-icon
                name="save"
                size="16"
                class="text-primary"
              ></lucide-icon>
              Save
            </button>
          </div>
        </mat-expansion-panel-header>
        <div id="reviewDetails">
          <div class="row ml-2">
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Review Date
                <!-- <span class="stars">*</span> -->
              </label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="reviewDate"
                  (click)="reviewDate.open()"
                  class="form-control form-control-sm border-bottom"
                  name="reviewDate"
                  [(ngModel)]="overallAssessmentData.reviewDate"
                  [disabled]="!userPermissionList?.ReviewDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="reviewDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #reviewDate></mat-datepicker>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Reviewer Name
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-chip-grid class="t3_matchip" #reviewerInputList>
                <ng-container *ngFor="let item of reviewerFilterList">
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeReview(item.value)"
                    class="mat-chip-category"
                  >
                    {{ item.name }}
                    <mat-icon
                      matChipRemove
                      *ngIf="userPermissionList?.ReviewerName"
                      >cancel</mat-icon
                    >
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #reviewerInput
                  [formControl]="searchReviewerCntrl"
                  [matAutocomplete]="reviewerAutoComplete"
                  [matChipInputFor]="reviewerInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addReview($event)"
                  #reviewerAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                  [readonly]="!userPermissionList?.ReviewerName"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #reviewerAutoComplete="matAutocomplete"
                (optionSelected)="selectedReviewerEvent($event)"
              >
                <mat-option *ngFor="let obj of searchedReviewers" [value]="obj.value">
                  <span class="option">
                    {{ obj.name }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Review Status
                <!-- <span class="stars">*</span> -->
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.reviewStatus"
                [disabled]="!userPermissionList?.ReviewStatus"
              >
                <mat-option
                  *ngFor="
                    let option of overallAssessmentDropdownList.reviewStatus
                  "
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div
              class="col-lg-3 mt-4 col-md-4 col-20"
            >
              <label class="control-label d-block fw"
                >Actions Required?
                <!-- <span class="stars">*</span> -->
              </label>
              <input
                [(ngModel)]="overallAssessmentData.isActionRequired"
                type="checkbox"
                style="vertical-align: middle; width: 16px; height: 16px"
                [disabled]="!userPermissionList?.ActionrRequiredReview"
              />
            </div>
            <div class="col-12 mt-5" *ngIf="!isBulkUpdate">
              <div class="header-text">
                <span class="control-label fw d-block mb-2">
                  Reviewer Comments</span
                >
              </div>
              <app-ck-editor-revision
                *ngIf="!isLoader"
                class="ck_editor_min_height"
                [accessType]="accessType"
                [data]="overallAssessmentData.reviewerComments"
                [userInfo]="user"
                [noteId]="'ReviewComments'"
                [editorUsers]="overallAssessmentData.muteReviewCommentsUsers"
                [selfAssessmentId]="summaryDetailsId"
                (childVariableChange)="
                  onChildVariableChangeT3($event, 'ReviewComments')
                "
                (saveEditorDate)="onEditorSave($event)"
                [isSaveDisable]="!userPermissionList?.ReviewerComments"
              ></app-ck-editor-revision>
            </div>
            <div class="col-12" *ngIf="!isBulkUpdate">
              <div
                class="cursor-pointer"
                (click)="uploadReviewEvidenceAssessment()"
              >
                <lucide-icon
                  class="text-blue-lucide mr-1"
                  size="15"
                  name="upload"
                ></lucide-icon>
                <span class="text-blue fw"
                  >Upload Evidence - Assessment
                  <i
                    *ngIf="isReviewLoader"
                    class="fa fa-circle-o-notch fa-spin"
                    style="font-size: 0.875rem; line-height: 1.5"
                  ></i>
                </span>
                <input
                  id="reviewEvidanceT3"
                  (change)="handleFileInputReview($event.target.files)"
                  type="file"
                  multiple
                  style="display: none"
                /><br />
              </div>
              <div
                class="col-lg-12 mt-3"
                *ngIf="selfAssessmentDocument.length > 0"
              >
                <ng-container *ngFor="let docs of selfAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 2">
                    <span
                      class="fa fa-trash pull-right delete-docs"
                      (click)="openDeleteModel(docs.id, 'review', userPermissionList?.UplEvdOvrAllReview)"
                    ></span>
                    <span
                      class="cursor-pointer"
                      (click)="
                        downloadDocument(
                          docs.id,
                          docs.fileName,
                          docs.fileExtension,
                          'review'
                        )
                      "
                    >
                      <i
                        class="fa fa-file-text fa-2x"
                        *ngIf="docs.fileExtension === '.txt'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-text-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.eml' ||
                          docs.fileExtension === '.msg'
                        "
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-pdf-o fa-2x"
                        *ngIf="docs.fileExtension === '.pdf'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.doc'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.docx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xls'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xlsx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-o fa-2x"
                        *ngIf="docs.fileExtension === '.csv'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-code-o fa-2x"
                        *ngIf="docs.fileExtension === '.xml'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-archive-o fa-2x"
                        *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpeg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.png'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.ppt' ||
                          docs.fileExtension === '.pptx'
                        "
                        aria-hidden="true"
                      ></i>
                    </span>
                    <div class="data-div">{{ docs.fileName }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div
    class="col-12 mt-2"
    [class.disabled-div]="!overallAssessmentData.isActionRequired"
  >
    <mat-accordion id="reviewDetails" class="mt-2">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel template-3-mat-panel">
          <div
            class="d-flex align-items-center w-100 gap-2 justify-content-between"
          >
            <mat-panel-title>
              <span class="text-header inc-f"> ASSESSMENT ACTIONS </span>
            </mat-panel-title>
            <button
              *ngIf="!versionHistoryData.isVersonHistory"
              [disabled]="isButtonDisabledAction ? true : !userPermissionList?.SaveOvrAllAction"
              class="save_btn mr-2 text-primary cursor-pointer"
              (click)="saveAssessmentActionData(); $event.stopPropagation()"
            >
              <lucide-icon
                name="save"
                size="16"
                class="text-primary"
              ></lucide-icon>
              Save
            </button>
          </div>
        </mat-expansion-panel-header>
        <div id="reviewDetails">
          <div class="row ml-2">
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Action Type
              </label>
              <mat-select
                class="select_border_t3"
                [(ngModel)]="overallAssessmentData.actionType"
                [disabled]="!userPermissionList?.ActionType"
              >
                <mat-option
                  *ngFor="
                    let option of overallAssessmentDropdownList.actionTypeList
                  "
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Action Owner
              </label>
              <mat-chip-grid class="t3_matchip" #actionOwnerInputList>
                <ng-container *ngFor="let item of actionOwnerFilterList">
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeActionOwner(item.value)"
                    class="mat-chip-category"
                  >
                    {{ item.name }}
                    <mat-icon
                      matChipRemove
                      *ngIf="userPermissionList?.ActionOwner"
                      >cancel</mat-icon
                    >
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #actionOwnerInput
                  [formControl]="searchActionOwnerCntrl"
                  [matAutocomplete]="actionOwnerAutoComplete"
                  [matChipInputFor]="actionOwnerInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addActionOwner($event)"
                  #actionOwnerAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                  [readonly]="!userPermissionList?.ActionOwner"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #actionOwnerAutoComplete="matAutocomplete"
                (optionSelected)="selectedActionOwnerEvent($event)"
              >
                <mat-option *ngFor="let obj of searchedActionOwner" [value]="obj.value">
                  <span class="option">
                    {{ obj.name }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Action Due Date
                <!-- <span class="stars">*</span> -->
              </label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="actiondueDate"
                  (click)="actiondueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  name="actiondueDate"
                  [(ngModel)]="overallAssessmentData.actionDueDate"
                  [disabled]="!userPermissionList?.ActionDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="actiondueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #actiondueDate></mat-datepicker>
            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label fw"
                >Action Closed
                <!-- <span class="stars">*</span> -->
              </label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="actionClosed"
                  (click)="actionClosed.open()"
                  class="form-control form-control-sm border-bottom"
                  name="actionClosed"
                  [(ngModel)]="overallAssessmentData.actionClosed"
                  [disabled]="!userPermissionList?.ActionClosed"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="actionClosed.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #actionClosed></mat-datepicker>
            </div>

            <div class="col-12 mt-5" *ngIf="!isBulkUpdate">
              <div class="header-text">
                <span class="control-label fw d-block mb-2">
                  Action Details</span
                >
              </div>
              <app-ck-editor-revision
                *ngIf="!isLoader"
                class="ck_editor_min_height"
                [accessType]="accessType"
                [data]="overallAssessmentData.actionDetails"
                [userInfo]="user"
                [noteId]="'ActionDetails'"
                [editorUsers]="overallAssessmentData.muteActionDetailsUsers"
                [selfAssessmentId]="summaryDetailsId"
                (childVariableChange)="
                  onChildVariableChangeT3($event, 'ActionDetails')
                "
                (saveEditorDate)="onEditorSave($event)"
                [isSaveDisable]="!userPermissionList?.ActionDetails"
              ></app-ck-editor-revision>
            </div>
            <div class="col-12 mt-3" *ngIf="!isBulkUpdate">
              <div class="header-text">
                <span class="control-label fw mb-2 d-block">
                  Action Closure – Supporting Rationale </span
                >
              </div>
              <app-ck-editor-revision
                *ngIf="!isLoader"
                class="ck_editor_min_height"
                [accessType]="accessType"
                [data]="overallAssessmentData.actionClosureSupportingRationale"
                [userInfo]="user"
                [noteId]="'ActionClosure'"
                [editorUsers]="overallAssessmentData.muteActionClosureUsers"
                [selfAssessmentId]="summaryDetailsId"
                (childVariableChange)="
                  onChildVariableChangeT3($event, 'ActionClosure')
                "
                (saveEditorDate)="onEditorSave($event)"
                [isSaveDisable]="!userPermissionList?.ActionClosure"
              ></app-ck-editor-revision>
            </div>
            <div class="col-12" *ngIf="!isBulkUpdate">
              <div
                class="cursor-pointer"
                (click)="uploadActionEvidenceAssessment()"
              >
                <lucide-icon
                  class="text-blue-lucide mr-1"
                  size="15"
                  name="upload"
                ></lucide-icon>
                <span class="text-blue fw"
                  >Upload Evidence - Actions
                  <i
                    *ngIf="isActionLoader"
                    class="fa fa-circle-o-notch fa-spin"
                    style="font-size: 0.875rem; line-height: 1.5"
                  ></i>
                </span>
                <input
                  id="ActionEvidanceT3"
                  (change)="handleFileInputAction($event.target.files)"
                  type="file"
                  multiple
                  style="display: none"
                /><br />
              </div>
              <div
                class="col-lg-12 mt-3"
                *ngIf="selfAssessmentDocument.length > 0"
              >
                <ng-container *ngFor="let docs of selfAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === 3">
                    <span
                      class="fa fa-trash pull-right delete-docs"
                      (click)="openDeleteModel(docs.id, 'action', userPermissionList?.UplEvdAction)"
                    ></span>
                    <span
                      class="cursor-pointer"
                      (click)="
                        downloadDocument(
                          docs.id,
                          docs.fileName,
                          docs.fileExtension,
                          'action'
                        )
                      "
                    >
                      <i
                        class="fa fa-file-text fa-2x"
                        *ngIf="docs.fileExtension === '.txt'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-text-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.eml' ||
                          docs.fileExtension === '.msg'
                        "
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-pdf-o fa-2x"
                        *ngIf="docs.fileExtension === '.pdf'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.doc'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-word-o fa-2x"
                        *ngIf="docs.fileExtension === '.docx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xls'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-excel-o fa-2x"
                        *ngIf="docs.fileExtension === '.xlsx'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-o fa-2x"
                        *ngIf="docs.fileExtension === '.csv'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-code-o fa-2x"
                        *ngIf="docs.fileExtension === '.xml'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-archive-o fa-2x"
                        *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpeg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.jpg'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-image-o fa-2x"
                        *ngIf="docs.fileExtension === '.png'"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="
                          docs.fileExtension === '.ppt' ||
                          docs.fileExtension === '.pptx'
                        "
                        aria-hidden="true"
                      ></i>
                    </span>
                    <div class="data-div">{{ docs.fileName }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
